import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import CrmsModal from "../../../core/modals/crms_modal";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";

interface supportTeamData {
  ID: number;
  team_name: string;
  employee_name: string;
  email_id: string;
  department: string;
  photo: string;
}
interface supportTeam {
  success: boolean;
  message: string;
  statusCode: number;
  data: supportTeamData[];
}
const SupportTeam = () => {
  const routes = all_routes;

  const columns = [
    {
      title: "SNo.",
      dataIndex: "Sno",
      sorter: (a: any, b: any) => a.Department.length - b.Department.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a: any, b: any) => a.Department.length - b.Department.length,
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div
            className="avatar avatar-md border avatar-rounded"
            style={{ width: "35px", height: "35px", overflow: "hidden" }}
          >
            <ImageWithBasePath
              src={
                record.Image ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQABqQIdskCD9BK0I81EbVfV9tTz320XvJ35A&s"
              }
              className="img-fluid fixed-avatar-img"
              alt="img"
            />
          </div>
          <div className="ms-2">
            <h6 className="fw-medium">{text}</h6>
            <span className="fs-12 fw-normal">{record.Department}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      render: (text: string) => (
        <a href={`mailto:${text}`} className="">
          {text}
        </a>
      ),
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },
  ];

  const { data: supportTeamResponse, loading: typeLoading } =
    useApi<supportTeam>("/api/get-support-team", {
      method: "GET",
      autoCall: true,
    });

  const data =
    supportTeamResponse?.data?.map((item, index) => ({
      Sno: index + 1,
      key: item.ID,
      Department: item.department,
      Name: item.employee_name,
      Email: item.email_id,
      Image: item.photo,
    })) || [];

  return (
    <>
      {<Loader loading={typeLoading} />}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Support Team </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Career & Support</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Support Team
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center justify-content-end flex-wrap ">
              <div className="mb-2"></div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Contact List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Support Team</h5>
            </div>
            <div className="card-body p-0">
              <Table dataSource={data} columns={columns} Selection={false}  showSearchInput={true}/>
            </div>
          </div>
          {/* /Contact List */}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      <CrmsModal />
    </>
  );
};

export default SupportTeam;
